import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { CLASS_MODE } from 'src/app/constants';
import { HelperService } from 'src/app/helper.service';

@Component({
  selector: 'app-home-search-form',
  templateUrl: './home-search-form.component.html',
  styleUrls: ['./home-search-form.component.scss']
})
export class HomeSearchFormComponent implements OnInit {
  @ViewChild("placesRef", { static: true }) placesRef: GooglePlaceDirective;
  

  searchForm: FormGroup

  serviceTypeList$: Observable<any[]>
  specialityList$: Observable<any[]>
  specialityCategoryList$: Observable<any[]>

  modeList = CLASS_MODE;

  

  constructor(
    private router: Router,
    private apiService: ApiService,
    private fb: FormBuilder,
    private helper: HelperService
  ) {

    this.searchForm = this.fb.group({
      categoryId: ['', Validators.required],
      specialityId: [''],
      mode: ['']
    })

  }

  get categoryId() {
    return this.searchForm.get('categoryId');
  }
  get specialityId() {
    return this.searchForm.get('specialityId');
  }
  get mode() {
    return this.searchForm.get('mode');
  }

  

  ngOnInit(): void {
    this.serviceTypeList$ = this.apiService.getVenDetails({})
      .pipe(
        map((el: any) => el.data.venDetails.data)
      )

    this.specialityCategoryList$ = this.apiService.getSpecialityCategory({}) as Observable<any[]>;

  }

  onSearch() {
    if (this.searchForm.valid) {
      this.router.navigate([`search-class-results` + `/` + this.categoryId.value + `/` + this.specialityId.value], { queryParams: { mode: this.mode.value } });
    } else {
      alert("Please Select Category");
    }
  }

  onCategoryChange() {
    this.specialityList$ = this.apiService.getspetialityDetails({ vendorType: this.categoryId.value })
      .pipe(
        map((el: any) => el.data.venSplDetails.data)
      )
  }

  handleAddressChange(address: Address) {
    this.helper.setSearchLocation(address);
  }

}
